import { render, staticRenderFns } from "./LocationIndex.vue?vue&type=template&id=676674f1"
import script from "./LocationIndex.vue?vue&type=script&lang=ts"
export * from "./LocationIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports